// extracted by mini-css-extract-plugin
module.exports = {"option":"search-common_option__egMCm"};